import { ReactNode, isValidElement } from 'react'

export const getKeyFromValueOrElement = (val: string | number | ReactNode) => {
  return isValidElement(val) ? (val.key as string) : (val as string)
}
